var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21376 4.27637C2.93514 4.27637 2.70483 4.50667 2.70483 4.7853V5.56226H12.2941V4.7853C12.2941 4.50667 12.0638 4.27637 11.7852 4.27637H3.21376ZM12.2941 6.68726H2.70483V11.2139C2.70483 11.4925 2.93514 11.7228 3.21376 11.7228H11.7852C12.0638 11.7228 12.2941 11.4925 12.2941 11.2139V6.68726ZM1.57983 4.7853C1.57983 3.88535 2.31382 3.15137 3.21376 3.15137H11.7852C12.6851 3.15137 13.4191 3.88535 13.4191 4.7853V11.2139C13.4191 12.1138 12.6851 12.8478 11.7852 12.8478H3.21376C2.31382 12.8478 1.57983 12.1138 1.57983 11.2139V4.7853ZM8.8125 9.87475C8.8125 9.5641 9.06434 9.31226 9.375 9.31226H10.625C10.9357 9.31226 11.1875 9.5641 11.1875 9.87475C11.1875 10.1854 10.9357 10.4373 10.625 10.4373H9.375C9.06434 10.4373 8.8125 10.1854 8.8125 9.87475Z",
    fill: "#748399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.31eb4ff7f558bc3105fc38d776411376.svg";
export { ForwardRef as ReactComponent };